import PublicTeacherAcademicTitleTable from "./PublicTeacherAcademicTitleTable";

export default PublicTeacherAcademicTitleTable